<template>
  <footer class="footer">
      <hr/>
      <div class="text-center">
          <small>&copy; 2014-{{thisYear}}</span> アスニピース株式会社</small>
      </div>
  </footer>
</template>

<style scoped>
</style>

<script>
import moment from 'moment'

export default {
  name: "asn-footer",
  data() {
    return {
      thisYear: moment().format("YYYY")
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/assets/js/components/AsnFooter.vue